import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

// Import local images from pdf folder
import GameCityLogo from '../images/pdf/Game City Logo_1.png';
import XmasCard2 from '../images/pdf/GC Xmas Card V1_CMYK-2.png';
import XmasCard3 from '../images/pdf/GC Xmas Card V1_CMYK-3.png';
import FireTVLogo from '../images/pdf/Fire TV Logo.png';
import RokuLogo from '../images/pdf/Roku Logo.png';

// HTML template for the codes download PDF
const getVoucherHtml = (productsHtml, images) => `
<!DOCTYPE html>
<html>
<head>
    <style>
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background-color: #70149d; font-family: Arial, Helvetica, sans-serif; }
        .container { width: 600px; margin: 0 auto; background-color: #70149d; padding-bottom: 30px; }
        .logo-section { text-align: center; padding: 30px 0 20px 0; }
        .logo-section img { max-width: 140px; height: auto; }
        .card-img { display: block; margin: 10px auto; max-width: 360px; width: 100%; height: auto; }
        .text-section { color: #ffffff; font-size: 18px; text-align: center; padding: 10px 20px; line-height: 1.4; }
        .products-section { color: #ffffff; font-size: 25px; font-weight: 700; text-align: center; padding: 15px 10px; }
        .product-item { margin-bottom: 15px; }
        .product-name { font-size: 22px; margin-bottom: 5px; }
        .product-code { font-size: 16px; font-family: monospace; background: rgba(255,255,255,0.15); padding: 8px 15px; border-radius: 5px; display: inline-block; margin: 3px 0; }
        .platforms { display: flex; justify-content: center; align-items: center; gap: 40px; padding: 20px 40px; }
        .platform-logo { width: auto; height: 40px; object-fit: contain; }
        .social-section { text-align: center; padding: 20px; }
        .social-icons { display: inline-flex; gap: 10px; }
        .social-icons img { width: 32px; height: 32px; }
        .footer { text-align: center; padding: 20px 15px 10px 15px; color: #ffffff; font-size: 13px; }
        .footer a { color: #ffffff; }
    </style>
</head>
<body>
    <div class="container">
        <!-- Logo -->
        <div class="logo-section">
            <img src="${images.logo}" alt="Game City">
        </div>

        <!-- Intro Text -->
        <div class="text-section">
            <p>You're one step away from the action...<br>Your activation codes are below:</p>
        </div>

        <!-- Products/Codes -->
        <div class="products-section">
            ${productsHtml}
        </div>

        <!-- How to Play Card -->
        <img class="card-img" src="${images.card2}" alt="">

        <!-- Instructions -->
        <div class="text-section">
            <p>Ready to play? Here's how to activate your games at <strong>www.game.city</strong>:</p>
            <p><strong>1.</strong> Log in or create an account</p>
            <p><strong>2.</strong> Enter your activation code</p>
            <p><strong>3.</strong> Enjoy the game!</p>
        </div>

        <!-- Where to Play Card -->
        <img class="card-img" src="${images.card3}" alt="">

        <!-- Platform Text -->
        <div class="text-section">
            <p>You can also create your account and access your entire library of games on one of our TV apps, available on the devices listed below:</p>
        </div>

        <!-- Platform Logos -->
        <div class="platforms">
            <img class="platform-logo" src="${images.fireTv}" alt="Fire TV">
            <img class="platform-logo" src="${images.roku}" alt="Roku">
        </div>

        <!-- Social Icons -->
        <div class="social-section">
            <div class="social-icons">
                <img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/twitter@2x.png" alt="Twitter">
                <img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/facebook@2x.png" alt="Facebook">
                <img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/instagram@2x.png" alt="Instagram">
                <img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/tiktok@2x.png" alt="TikTok">
                <img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/youtube@2x.png" alt="YouTube">
            </div>
        </div>

        <!-- Footer -->
        <div class="footer">
            <p>www.game.city</p>
        </div>
    </div>
</body>
</html>
`;

const generateProductsHtml = (products) => {
    let html = '';
    products.forEach((product) => {
        html += `<div class="product-item">`;
        html += `<div class="product-name">${product.productName}</div>`;
        // Show ALL codes for this product
        product.codes.forEach((code) => {
            html += `<div class="product-code">${code}</div>`;
        });
        html += `</div>`;
    });
    return html;
};

export const generateVoucherPdf = async (products, recipientEmail = '') => {
    // Local image references
    const images = {
        logo: GameCityLogo,
        card2: XmasCard2,
        card3: XmasCard3,
        fireTv: FireTVLogo,
        roku: RokuLogo,
    };

    // Generate products HTML
    const productsHtml = generateProductsHtml(products);
    const fullHtml = getVoucherHtml(productsHtml, images);

    // Create a hidden container for rendering
    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.style.width = '600px';
    document.body.appendChild(container);

    // Create an iframe to isolate styles
    const iframe = document.createElement('iframe');
    iframe.style.width = '600px';
    iframe.style.height = 'auto';
    iframe.style.border = 'none';
    iframe.style.visibility = 'hidden';
    container.appendChild(iframe);

    // Write HTML to iframe
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(fullHtml);
    iframeDoc.close();

    // Wait for images to load
    await new Promise((resolve) => {
        const imgElements = iframeDoc.querySelectorAll('img');
        let loadedCount = 0;
        const totalImages = imgElements.length;

        if (totalImages === 0) {
            resolve();
            return;
        }

        const checkLoaded = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
                resolve();
            }
        };

        imgElements.forEach((img) => {
            if (img.complete) {
                checkLoaded();
            } else {
                img.onload = checkLoaded;
                img.onerror = checkLoaded;
            }
        });

        // Fallback timeout
        setTimeout(resolve, 3000);
    });

    // Small delay to ensure rendering is complete
    await new Promise(resolve => setTimeout(resolve, 500));

    try {
        // Get the actual content container
        const contentContainer = iframeDoc.querySelector('.container');
        const actualHeight = contentContainer ? contentContainer.scrollHeight : iframeDoc.body.scrollHeight;

        // Update iframe height to match content
        iframe.style.height = `${actualHeight}px`;

        // Capture only the content container
        const elementToCapture = contentContainer || iframeDoc.body;
        const canvas = await html2canvas(elementToCapture, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#70149d',
            width: 600,
            height: actualHeight,
            windowWidth: 600,
            windowHeight: actualHeight,
        });

        // Create PDF with appropriate size
        const imgData = canvas.toDataURL('image/png');
        const pdfWidth = 210; // A4 width in mm
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        // Use custom page size to fit content exactly (no extra pages)
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [pdfWidth, pdfHeight]
        });

        // Add the image, fitting to page
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        // Save the PDF
        const fileName = `GameCity_Codes_${new Date().toISOString().split('T')[0]}.pdf`;
        pdf.save(fileName);
    } finally {
        // Cleanup
        document.body.removeChild(container);
    }
};

export default { generateVoucherPdf };
